import styled from '@emotion/styled'

export const ButtonArea = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;

  & > button {
    background-color: #2979FF;
    color: white;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;

    &:hover {
      background-color: #2d6ada;
    }

    @media (max-width: 600px) {
      width: 100%;
    }
  }
`
